export default {
  catagoryList: [],
  advertList: [],       // 首页轮播列表
  indexCourseList: [],  // 首页内容列表
  indexCourseObj: {}  // 首页请求参数
};



// WEBPACK FOOTER //
// ./src/store/user/state.home.js